/// <amd-module name="VC/ProjectOverview/CodeProjectAboutService" />
import * as React from "react";

import { Services, VssService } from "VSS/Platform/Context";

import {
    IProjectAboutRegionProvider
} from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Components/AboutProject/PanelAboutRegion/Interfaces";
import { CodeAboutRegion } from "VC/ProjectOverview/CodeAboutRegion";
import * as Resources from "VC/ProjectOverview/Resources";

class CodeProjectAboutService extends VssService implements IProjectAboutRegionProvider {
    public getAboutRegion(
        readMode: boolean,
        repoId: string | undefined,
        repoIdChanged: (repoId: string) => void,
        markTimeToInteractive: (source: string) => void,
        showError: boolean
    ): JSX.Element {
        return <CodeAboutRegion
            readMode={readMode}
            repoId={repoId}
            onRepositoryChanged={repoIdChanged}
            markTimeToInteractive={markTimeToInteractive}
            showError={showError} />;
    }

    public getChoiceName(): string {
        return Resources.ReadmeChoiceName;
    }
}

Services.add("VC.ProjectAboutService", { serviceFactory: CodeProjectAboutService });
